import {
  createListenerMiddleware,
  isAnyOf,
  type TypedStartListening,
} from "@reduxjs/toolkit";

import { setSelectedAccounts } from "actions/accountPicker";
import { updateSelectedAccounts } from "actions/commonActions";
import { setLocalStorageSelectedAccounts } from "libs/storage/adapters";
import { getSelectedAccountIds } from "selectors/skedCoreSelectors";

export const selectedAccountsPersistenceMiddleware = createListenerMiddleware();

export function registerSelectedAccountsPersistenceListeners(
  startListening: TypedStartListening<
    any,
    any
  > = selectedAccountsPersistenceMiddleware.startListening
) {
  startListening({
    matcher: isAnyOf(setSelectedAccounts, updateSelectedAccounts),
    effect: async (_, api) => {
      const selectedAccountIds = getSelectedAccountIds(api.getState());

      setLocalStorageSelectedAccounts(JSON.stringify(selectedAccountIds));
    },
  });
}

registerSelectedAccountsPersistenceListeners();
